import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';
import { articleContents } from '@/mocks/articleContents';

const heroImages: Record<string, string> = {
  'article-001': 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20livestream%20studio%20with%20neon%20lights%20and%20smartphone%20screens%20glowing%20in%20darkness%2C%20abstract%20artistic%20composition%20with%20lime%20green%20accents%2C%20dark%20moody%20atmosphere%2C%20modern%20Chinese%20entertainment%20industry%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%20style%20with%20cinematic%20lighting&width=1800&height=900&seq=art-hero-001&orientation=landscape',
  'article-002': 'https://readdy.ai/api/search-image?query=Blurry%20paparazzi%20style%20tropical%20beach%20sunset%20scene%20with%20palm%20trees%20and%20ocean%20waves%2C%20warm%20golden%20light%2C%20mysterious%20romantic%20atmosphere%2C%20artistic%20grain%20texture%2C%20editorial%20celebrity%20gossip%20photography%2C%20soft%20focus%20dreamy%20quality&width=1800&height=900&seq=art-hero-002&orientation=landscape',
  'article-003': 'https://readdy.ai/api/search-image?query=Dramatic%20still%20life%20of%20broken%20cosmetics%20and%20packaging%20scattered%20on%20dark%20surface%2C%20harsh%20spotlight%20creating%20dramatic%20shadows%2C%20lime%20green%20warning%20tape%20accents%2C%20editorial%20product%20photography%2C%20dark%20moody%20atmosphere%2C%20high%20detail&width=1800&height=900&seq=art-hero-003&orientation=landscape',
  'article-004': 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20two%20separate%20elegant%20modern%20apartments%20with%20different%20color%20schemes%2C%20subtle%20storytelling%20through%20interior%20design%20details%2C%20warm%20and%20cool%20lighting%20contrast%2C%20cinematic%20framing%2C%20artistic%20editorial%20photography%2C%20sophisticated%20mood&width=1800&height=900&seq=art-hero-004&orientation=landscape',
  'article-005': 'https://readdy.ai/api/search-image?query=Abstract%20composition%20of%20graduation%20certificates%20and%20stage%20spotlights%20overlapping%20in%20dark%20space%2C%20dramatic%20contrast%20between%20academic%20symbols%20and%20entertainment%20glamour%2C%20lime%20green%20accent%20lighting%2C%20editorial%20photography&width=1800&height=900&seq=art-hero-005&orientation=landscape',
  'article-006': 'https://readdy.ai/api/search-image?query=Dramatic%20outdoor%20film%20set%20scene%20with%20equipment%20and%20lighting%20rigs%20against%20moody%20sky%2C%20subtle%20emergency%20vehicle%20lights%20in%20distance%2C%20cinematic%20composition%2C%20news%20journalism%20photography%20style%2C%20tense%20atmosphere&width=1800&height=900&seq=art-hero-006&orientation=landscape',
  'article-007': 'https://readdy.ai/api/search-image?query=Abstract%20split%20screen%20composition%20showing%20two%20contrasting%20smartphone%20screens%20with%20social%20media%20interfaces%20glowing%20in%20dark%20space%2C%20dramatic%20lime%20green%20and%20warm%20amber%20light%20split%2C%20digital%20conflict%20aesthetic&width=1800&height=900&seq=art-hero-007&orientation=landscape',
  'article-008': 'https://readdy.ai/api/search-image?query=Dark%20cinema%20auditorium%20with%20single%20spotlight%20on%20empty%20director%20chair%2C%20dramatic%20shadow%20play%2C%20mysterious%20and%20tense%20atmosphere%2C%20film%20industry%20aesthetic%2C%20editorial%20investigative%20journalism%20photography%2C%20cinematic%20noir&width=1800&height=900&seq=art-hero-008&orientation=landscape',
  'article-009': 'https://readdy.ai/api/search-image?query=Elegant%20red%20carpet%20event%20with%20dramatic%20spotlight%20and%20camera%20flashes%2C%20glamorous%20atmosphere%2C%20fashion%20photography%20aesthetic%2C%20warm%20gold%20and%20champagne%20tones%2C%20sophisticated%20luxury%20event&width=1800&height=900&seq=art-hero-009&orientation=landscape',
};

const comments = [
  { name: '吃瓜不睡觉', text: '太震撼了！我就说这个网红早晚要出事，人设崩塌只是时间问题。', likes: 2341, time: '2小时前' },
  { name: '真相挖掘机', text: '其实业内早就有风声了，只是没人敢第一个爆出来。吃瓜51果然是吃瓜界的扛把子！', likes: 1892, time: '3小时前' },
  { name: '娱乐圈观察员', text: '细节描述得太到位了，这才是真正的深度爆料。点赞！', likes: 1567, time: '4小时前' },
];

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const fallbackArticle = articles[0];
  const article = articles.find((a) => a.id === id) || fallbackArticle;
  const content = articleContents.find((c) => c.id === id);

  if (!article || !content) {
    return (
      <>
        <Navbar />
        <main className="min-h-[60vh] flex items-center justify-center pt-20">
          <div className="text-center">
            <h1 className="font-heading font-black text-2xl text-foreground-950 mb-2">文章不存在</h1>
            <Link to="/" className="text-sm text-accent-600 hover:text-accent-700 cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const relatedArticles = content.relatedArticles
    .map((rid) => articles.find((a) => a.id === rid))
    .filter(Boolean) as typeof articles;

  const nextArticle = relatedArticles[0];

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        '@id': `http://818tp.cn/article/${article.id}#article`,
        headline: article.title,
        description: article.summary,
        author: { '@type': 'Organization', name: article.author, url: 'http://818tp.cn/about' },
        datePublished: article.date,
        publisher: { '@id': 'http://818tp.cn/#organization' },
        isPartOf: { '@id': 'http://818tp.cn/#website' },
        mainEntityOfPage: { '@type': 'WebPage', '@id': `http://818tp.cn/article/${article.id}#webpage` },
      },
      {
        '@type': 'BreadcrumbList',
        '@id': `http://818tp.cn/article/${article.id}#breadcrumb`,
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://818tp.cn/' },
          { '@type': 'ListItem', position: 2, name: article.category, item: `http://818tp.cn/category/${article.categorySlug}` },
          { '@type': 'ListItem', position: 3, name: article.title },
        ],
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
      />
      <Navbar />
      <main>
        <section className="relative w-full min-h-[420px] md:min-h-[520px] flex items-center overflow-hidden" aria-labelledby="article-hero-title">
          <div className="absolute inset-0">
            <img
              src={heroImages[article.id] || heroImages['article-001']}
              alt=""
              className="w-full h-full object-cover object-top"
              aria-hidden="true"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          </div>

          <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-16 md:pt-28 md:pb-20">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row lg:items-end gap-6 lg:gap-16">
                <div className="lg:w-1/2">
                  <nav className="flex items-center gap-2 text-xs font-label text-background-50/60 mb-4 flex-wrap" aria-label="面包屑导航">
                    <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer">首页</Link>
                    <i className="ri-arrow-right-s-line"></i>
                    <Link to={`/category/${article.categorySlug}`} className="hover:text-background-50 transition-colors cursor-pointer">{article.category}</Link>
                    <i className="ri-arrow-right-s-line"></i>
                    <span className="text-accent-400 line-clamp-1">{article.title}</span>
                  </nav>
                  <h1 id="article-hero-title" className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-background-50 leading-tight tracking-tight">
                    {article.title}
                  </h1>
                </div>
                <div className="lg:w-1/2">
                  <p className="text-sm text-background-50/70 leading-relaxed mb-3 line-clamp-2">
                    {article.summary}
                  </p>
                  <div className="flex items-center gap-4 flex-wrap">
                    <span className="text-xs text-background-50/60 font-label">
                      <i className="ri-user-line mr-1"></i>{article.author}
                    </span>
                    <span className="text-xs text-background-50/60 font-label">
                      <i className="ri-calendar-line mr-1"></i>{article.date}
                    </span>
                    <span className="text-xs text-background-50/60 font-label">
                      <i className="ri-eye-line mr-1"></i>{(article.readCount / 10000).toFixed(1)}万阅读
                    </span>
                  </div>
                  <Link
                    to={`/category/${article.categorySlug}`}
                    className="inline-flex items-center gap-2 text-sm font-label font-bold text-accent-400 hover:text-accent-300 transition-colors group cursor-pointer mt-4"
                  >
                    返回列表
                    <i className="ri-arrow-left-line group-hover:-translate-x-1 transition-transform"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent z-[5]"></div>
        </section>

        <article className="py-10 md:py-14 bg-background-50">
          <div className="max-w-3xl mx-auto px-4 md:px-8">
            <div
              className="prose-custom"
              dangerouslySetInnerHTML={{ __html: content.contentHtml }}
            />
          </div>
        </article>

        <section className="py-14 md:py-20 bg-secondary-50/60" aria-labelledby="author-title">
          <div className="max-w-3xl mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">
              <div className="lg:w-auto flex-shrink-0">
                <p className="text-xs font-label font-medium text-foreground-400 mb-2">
                  / 关于作者
                </p>
              </div>
              <div className="lg:flex-1">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
                  吃瓜51编辑团队深耕娱乐资讯领域多年，拥有广泛的业内人脉和独家信息渠道。我们承诺每一条爆料都经过多方核实，坚持为读者提供真实、独家的吃瓜内容。
                </p>
                <div className="flex items-center gap-4">
                  <div className="flex -space-x-3">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20Chinese%20media%20professional%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20high%20quality%20headshot%20style&width=80&height=80&seq=team-avatar-01&orientation=squarish"
                      alt="团队成员1"
                      className="w-10 h-10 rounded-full border-2 border-secondary-100 object-cover"
                      loading="lazy"
                    />
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20Chinese%20female%20journalist%2C%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20high%20quality%20headshot&width=80&height=80&seq=team-avatar-02&orientation=squarish"
                      alt="团队成员2"
                      className="w-10 h-10 rounded-full border-2 border-secondary-100 object-cover"
                      loading="lazy"
                    />
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20circular%20avatar%20portrait%20of%20Chinese%20young%20media%20editor%2C%20warm%20studio%20lighting%2C%20clean%20minimal%20background%2C%20editorial%20portrait%20photography%2C%20high%20quality%20headshot&width=80&height=80&seq=team-avatar-03&orientation=squarish"
                      alt="团队成员3"
                      className="w-10 h-10 rounded-full border-2 border-secondary-100 object-cover"
                      loading="lazy"
                    />
                  </div>
                  <p className="text-xs text-foreground-500 font-label">
                    吃瓜51编辑团队 · 多位资深娱乐记者联合出品
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50" aria-labelledby="comments-title">
          <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
            <h2 id="comments-title" className="font-body text-2xl md:text-3xl text-foreground-950 mb-2">
              <span className="text-foreground-400">「</span>
              读者热评
              <span className="text-foreground-400">」</span>
            </h2>

            <div className="mt-8 space-y-6">
              {comments.map((comment, idx) => (
                <div key={idx} className="text-left bg-background-100 rounded-xl p-5 md:p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-secondary-200 flex items-center justify-center">
                      <i className="ri-user-line text-foreground-500"></i>
                    </div>
                    <div>
                      <p className="text-sm font-label font-bold text-foreground-950">{comment.name}</p>
                      <p className="text-xs text-foreground-500">{comment.time}</p>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-3">&ldquo;{comment.text}&rdquo;</p>
                  <div className="flex items-center gap-1 text-foreground-400 text-xs">
                    <i className="ri-thumb-up-line"></i>
                    <span>{comment.likes}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex items-center justify-center gap-3 mt-8">
              <button className="w-10 h-10 flex items-center justify-center border border-foreground-200 rounded-lg text-foreground-700 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-200 cursor-pointer" aria-label="上一条评论">
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors duration-200 cursor-pointer" aria-label="下一条评论">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </section>

        {nextArticle && (
          <section className="py-14 md:py-20 bg-background-50" aria-labelledby="related-title">
            <div className="max-w-5xl mx-auto px-4 md:px-8">
              <div className="w-full rounded-3xl overflow-hidden mb-10 md:mb-14">
                <img
                  src={heroImages[nextArticle.id] || heroImages['article-001']}
                  alt={nextArticle.title}
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>

              <div className="text-center max-w-2xl mx-auto">
                <p className="font-heading font-black text-xl md:text-2xl text-foreground-950 leading-snug mb-3">
                  下一篇：<span className="italic font-serif font-normal text-foreground-600">{nextArticle.title}</span>
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-8 line-clamp-2">
                  {nextArticle.summary}
                </p>
                <Link
                  to={`/article/${nextArticle.id}`}
                  className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-label font-bold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
                >
                  阅读下一篇
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </section>
        )}
      </main>
      <Footer />
    </>
  );
}